/**
 * ResizeMeasurer higher order component
 *
 * This component is used to wrap a component and report that component's height
 * to it when it first measured and when it is resized. The height is passed down as
 * a prop called `divHeight`
 *
 * @module component/ResizeMeasurer/ResizeMeasurer
 */

import createReactClass from 'create-react-class';
import React from 'react';

import { RESIZE_THROTTLE } from '../../constants/ResizeMeasurer';
import {
  addWindowEventListener,
  clearTimeout,
  removeWindowEventListener,
  setTimeout,
} from '../../tools/Globals';

export default function ResizeMeasurer(
  ComposedComponent,
  useWindow = false,
  resizeOnMount = false,
) {
  return createReactClass({
    displayName: 'ResizeMeasurer',

    getInitialState() {
      return useWindow
        ? this.getWindowParams()
        : {
            divHeight: 1,
            divWidth: 1,
            divOffsetTop: 0,
          };
    },

    componentDidMount() {
      this.hasMounted = true;
      if (resizeOnMount) {
        this.measureWindow();
      }
      addWindowEventListener('resize', this.measureWindow);
    },

    componentWillReceiveProps() {
      if (this.refs.el && this.refs.el.clientHeight) {
        this.setState(
          useWindow
            ? this.getWindowParams()
            : {
                divHeight: this.refs.el.clientHeight,
                divWidth: this.refs.el.clientWidth,
                divOffsetTop: this.getOffsetTop(),
              },
        );
      }
    },

    componentWillUnmount() {
      removeWindowEventListener('resize', this.measureWindow);
      clearTimeout(this.windowTimeout);
    },

    hasMounted: false,

    getOffsetTop() {
      const rectTop = this.refs.el ? this.refs.el.getBoundingClientRect().top : 0;
      return window.pageYOffset + rectTop;
    },

    getWindowParams() {
      return {
        divHeight: document.documentElement.clientHeight || window.innerHeight,
        divWidth: document.documentElement.clientWidth || window.innerHeight,
        divOffsetTop: this.getOffsetTop(),
      };
    },

    measureWindow() {
      if (!this.hasMounted) {
        return;
      }
      const now = Date.now();
      if (now < this.lastResizeTime + RESIZE_THROTTLE) {
        if (!this.windowTimeout) {
          this.windowTimeout = setTimeout(this.measureWindow, RESIZE_THROTTLE);
        }
        return;
      }
      this.lastResizeTime = now;
      this.windowTimeout = null;

      if (this.refs.el && this.refs.el.clientHeight) {
        if (
          this.state.divHeight !== this.refs.el.clientHeight ||
          this.state.divWidth !== this.refs.el.clientWidth
        ) {
          this.setState(
            useWindow
              ? this.getWindowParams()
              : {
                  divHeight: this.refs.el.clientHeight,
                  divWidth: this.refs.el.clientWidth,
                  divOffsetTop: this.getOffsetTop(),
                },
          );
        }
      }
    },

    render() {
      return (
        <div className='measuredComponent' style={{ height: '100%', overflow: 'hidden' }} ref='el'>
          <ComposedComponent {...this.props} {...this.state} forceMeasure={this.measureWindow} />
        </div>
      );
    },
  });
}
